export function searchITunes(query) {
  const src = new URL('https://itunes.apple.com/search');
  for (const key in query) {
    src.searchParams.append(key, query[key]);
  }

  src.searchParams.append('callback', 'itunesSearchCallback');

  const script = document.createElement('script');
  script.src = src.toString();
  document.body.appendChild(script);

  return new Promise((resolve) => {
    window.itunesSearchCallback = (data) => {
      resolve(data.results?.[0] || null);
      script.remove();
    };
  });
}

export function searchITunesUrl(url) {
  const idMatch = url.match(/id\d+/);
  if (!idMatch) {
    return Promise.resolve(null);
  }

  const id = idMatch[0];

  return searchITunes({
    media: 'software',
    term: id,
  });
}
